import { PreviouslySelectedOptionIndex } from '../../../../ContentZone/student/Widgets/_shared/Question/api/getSavedOptionsForQuestion';
import { StudentStore } from '../../../models/Store';
import { QuestionWidgetTrackingState } from './questionWidgetTrackingReducer';
import { ContentItemType, SingleResponseQuestionWidget } from '@ael/core-api';
import { createSelector } from 'reselect';

const getQuestionWidgetTrackingState = (state: StudentStore) => state.tracking.questionWidget;

export const getPreviouslySelectedOptionForQuestionWidget = createSelector(
  getQuestionWidgetTrackingState,
  (state: QuestionWidgetTrackingState) =>
    (item: ContentItemType, questionWidget: SingleResponseQuestionWidget): PreviouslySelectedOptionIndex => {
      return (
        state.previouslySelectedOptionsForItems.get(item.trackingIdentifier)?.get(questionWidget.trackingIdentifier) ??
        null
      );
    }
);
